<template>
  <div id="app" 
    :class="{ 
      dawn: skytime == 'dawn', 
      day: skytime == 'day',
      dusk: skytime == 'dusk',
      night: skytime == 'night',
      mobile: isMobile,
    }"
    class="notranslate"
  >
    <Architecture 
      ref="architecture"
      :slug="slug" 
      :menu="menu" 
    />
  </div>
</template>

<script>
import Architecture from './views/Architecture.vue'
import smoothscroll from 'smoothscroll-polyfill'
import { EventBus } from './EventBus.js'

export default {
  name: "App",
  components: {
    Architecture,
  },
  data() {
    return {
      isMobile: Boolean,
      menu: false,
      stopScroll: false,
      skytime: '',
      slug: window.location.pathname.replace(this.$publicPath, ''),
    }
  },
  created() {
    this.CheckForMobile()
    window.addEventListener('resize', this.CheckForMobile)
  },
  mounted() {
    this.changeColor()
    setInterval(() => { this.changeColor() }, 100000)

    smoothscroll.polyfill()

    const architecture = this.$refs.architecture.$el
    const sections = Array.from(document.querySelectorAll('section .content'))

    architecture.addEventListener('wheel', this.transformScroll)
    architecture.addEventListener('scroll', this.toggleMenu)
    architecture.addEventListener('touchmove', this.toggleMenu)
    
    for (let s = 0; s < sections.length; s++) {
      let section = sections[s]
      section.addEventListener('wheel', (event) => {
        if (section.scrollHeight > section.clientHeight) {
          event.stopPropagation()
        }
      })
    }
  },
  methods: {
    CheckForMobile() {
      if (window.innerWidth <= 560) {
        EventBus.$root.mobile = true;
        this.isMobile = true
      }
      else { 
        EventBus.$root.mobile = false;
        this.isMobile = false
      }
    },
    transformScroll(e) {
      if (e.deltaY) {
        e.currentTarget.scrollLeft += event.deltaY + event.deltaX
        e.preventDefault()
      }
    },
    toggleMenu(e) {
      if (e.currentTarget.scrollLeft > 225) this.menu = true
      else this.menu = false
    },
    changeColor() {
      let skytime
      let d = new Date()
      let hour = d.getHours() + ( d.getTimezoneOffset() / 60 ) + 1
      if (!skytime) {
        if (8 <= hour && hour < 9) skytime = 'dawn'
        else if (9 <= hour && hour < 16) skytime = 'day'
        else if (16 <= hour && hour < 17) skytime = 'dusk'
        else if (17 <= hour || hour < 8) skytime = 'night'
      }
      if (skytime != this.skytime) {
        this.skytime = skytime
        document.documentElement.style.background = `var(--sky-${skytime})`
        document.body.style.background = `var(--sky-${skytime})`
        console.log(`It is now ${skytime} in Berlin.`)
      }
    },
  }
}

</script>

<style>

/* @font-face {
  font-family: HardTimes;
  src: url(assets/fonts/HardTimes/HardTimes\ Medium.ttf);
  font-weight: normal;
}
@font-face {
  font-family: HardTimes;
  src: url(assets/fonts/HardTimes/HardTimesBold.otf);
  font-weight: bold;
} */
@font-face {
  font-family: EBGar;
  src: url(assets/fonts/EB_Garamond/regular.ttf);
  font-style: normal;
}
@font-face {
  font-family: EBGar;
  src: url(assets/fonts/EB_Garamond/italic.ttf);
  font-style: italic;
}
@font-face {
  font-family: Almendra;
  src: url(assets/fonts/Almendra/Almendra-Regular.ttf);
  font-weight: normal;
}
@font-face {
  font-family: 'Unicode';
  src: url(assets/fonts/AppleMyungjo.otf);
  font-weight: normal;
}





:root {
  /* fonts */
  /* --font-color: #1a503c;  */
  --font-color: rgba(36,17,17,0.83);

  /* colors */
  --paler-yellow: rgb(255, 207, 196);
  --palest-yellow: rgb(246,222,210);
  /* --paler-yellow: rgb(235, 182, 171);
  --palest-yellow: rgb(240, 206, 188); */
  /* --paler-yellow: rgb(238, 230, 203);
  --palest-yellow: rgb(253,245,222); */

  --paler-yellow: rgb(243, 236, 214);
  --palest-yellow: rgb(250, 243, 223);
  
  /* --paler-yellow: rgb(238, 214, 178);
  --palest-yellow: rgb(240, 224, 191); */
  /* --paler-yellow: rgb(227, 245, 205);
  --palest-yellow: rgb(226, 247, 206); */
  /* --paler-yellow: rgb(226, 184, 156);
  --palest-yellow: rgb(231, 204, 185); */
  /* --paler-yellow: rgb(252, 251, 216);
  --palest-yellow: rgb(248, 243, 229); */
  /* --dark-green: rgba(35,81,51,0.98);
  --dark-yellow-green: rgb(65, 116, 50); */
    --dark-green: rgba(35,81,51,0.98);
  --dark-yellow-green: rgb(65, 116, 50);
  /* --dark-green: rgb(109,121,70);
  --dark-yellow-green: rgb(157,170,117); */
  --dark-red: rgb(175,46,47);
  --lighter-red:rgb(198,52,52);

  /* borders */
  --thin-grey: 0.5px solid rgb(0,0,0,0.1);
  --ridge-grey: 4px ridge rgba(177, 192, 204, 0.918);
  /* --ridge-brown: 4px ridge rgb(104, 63, 35); */
  --ridge-brown: 4px ridge rgb(238, 206, 184);

  /* furniture */
  /* --ground: #e4d0a6;
  --ground: #2a1b6b;
  --ground: #b17469;
  --ground: red;
  --ground: rgb(87, 57, 56);
  --ground: rgb(235, 182, 171);
  --ground: rgb(161, 138, 123);
  --ground: rgb(199, 176, 135); */
  --ground: rgb(197, 180, 150);
  --ground: #dbceb1;
  --ground: #d5dbb1;
  /* --ground: rgb(109,121,70); */
  /* --ground: rgb(164, 177, 141); */
  --ground: rgb(157,170,117);


  --glass: linear-gradient(180deg, rgba(112, 225, 248, 0.514) 0%, rgba(231, 245, 255, 0.74) 100%);
  --orange-wood: rgb(77, 46, 26);
  --light-orange-wood: rgb(87, 59, 42);
  --pale-green: rgb(184, 161, 112);
  --leaf: rgb(118, 136, 87);
  --leaf-border: rgb(85, 95, 66);
  --pot: rgb(167, 60, 45);
  --pot-border: rgb(146, 93, 86);
  --soil: rgb(85, 66, 59);
  --light-wood: rgb(155, 134, 94);
  --paper: rgb(180, 180, 180);
  --wall-socket-grey: rgb(228, 228, 228);
  --cable-grey: rgb(223, 222, 222);
  --computer-dark-grey: rgb(146, 146, 146);
  --twenty-grey: rgb(211, 211, 211);
  --thirty-grey: rgb(184, 184, 184);
  /* --fabric:  rgb(202, 184, 144);
  --fabric-light:  rgb(219, 201, 163); */
  --fabric:  rgb(207, 195, 168);
  --fabric-light:  rgb(221, 211, 189);

  /* light */
  --sunlight: rgba(255,255,255, 0.2);

  /* sky */
  --sky-dawn: linear-gradient(to bottom,rgb(55,75,164) 0%, rgb(154, 160,213) 70%, rgb(247, 212, 131) 100%);
  --sky-day: linear-gradient(180deg, rgba(147, 223, 238, 0.842) 0%, rgb(240, 243, 245) 100%);
  --sky-dusk: linear-gradient(to top, #f3c46d 0%, #f39e6d 30%, #e26868 100%);
  --sky-night: linear-gradient(to bottom, #031e41 0%, #3c7aa8 100%);

   /* window  */
  --window-dawn: linear-gradient(to bottom,rgb(55,75,164) 0%, rgb(93,107,177) 100%);
  --window-day: linear-gradient(180deg, rgba(147, 223, 238, 0.842) 0%, rgb(182,218,227) 100%);
  --window-dusk: linear-gradient(to top, rgba(219, 149, 127, 0.829) 0%, rgba(230, 130, 123, 0.767) 100%);
  --window-night: linear-gradient(to bottom, #fdffe85e 0%, rgba(252, 255, 213, 0.418) 100%);

   /* door  */
  --glass-dawn: linear-gradient(to bottom,rgba(55, 75, 164, 0.637) 0%, rgba(177, 175, 195, 0.89) 100%);
  --glass-day: linear-gradient(180deg, rgba(112, 225, 248, 0.514) 0%, rgba(231, 245, 255, 0.74) 100%);
  --glass-dusk: linear-gradient(to top, rgba(207, 191, 146, 0.548) 0%, #e69f5c7a 100%);
  --glass-night: linear-gradient(to bottom, #fdffe85e 0%, rgba(252, 255, 213, 0.418) 100%);
}

html, body {
  position: relative;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
html {
  /* overflow-y: hidden; */
}
body {
  /* height: 100vh; */
  /* width: 100vw; */
  /* overflow: scroll;   */
  /* overflow-y: hidden; */
  /* display: flex;
  justify-content: center;
  align-items: center; */
}
#app {
  /* font-family: 'HardTimes', 'Times New Roman', Times, serif; */
  font-family: 'EBGar', 'Times New Roman', Times, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 10.5pt;
  line-height: 1.2;
  color: var(--font-color);
}

.dawn { background: var(--sky-dawn) }
.day { background: var(--sky-day) }
.dusk { background: var(--sky-dusk) }
.night { background: var(--sky-night) }

.dawn #back-room .walls .wall.left-wall .window { background: var(--window-dawn) }
.day #back-room .walls .wall.left-wall .window { background: var(--window-day) }
.dusk #back-room .walls .wall.left-wall .window { background: var(--window-dusk) }
.night #back-room .walls .wall.left-wall .window { background: var(--window-night) }

.dawn #back-room .walls .wall.left-wall .door { background: var(--glass-dawn) }
.day #back-room .walls .wall.left-wall .door { background: var(--glass-day) }
.dusk #back-room .walls .wall.left-wall .door { background: var(--glass-dusk) }
.night #back-room .walls .wall.left-wall .door { background: var(--glass-night) }

.night #outside .torrey { filter: brightness(0.6) grayscale(0.2);}


 /* DEFAULTS */

a, a:hover, a:active, a:focus, a:visited {
  color: var(--font-color);
  cursor: pointer;
  text-decoration: underline;
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
a.strike {
  text-decoration: line-through;
}
p { 
  margin-bottom: 1.2em;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
section {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  border-right: var(--thin-grey);
}


/* NAV */

#tagline {
  margin-left: 20px;
  margin-top: 40px;
  margin-right: 10px;
}
section#nav {
  flex: 1 1 auto;
  width: auto;
  border: none;
}
section nav {
  box-sizing: border-box;
  padding: 20px;
  padding-top: 0px;
}
section nav ul li {
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
section nav ul:hover li {
  opacity: 0.3;
  transition: opacity 0.2s ease;
}
section nav ul li:hover {
  opacity: 1;
}
section nav ul li:before { 
  content: '→ '; 
  margin-right: 5px; 
}
section nav ul li a,
section nav ul li a:hover {
  text-decoration: none;
}



 /* COLUMNS  */

section {
  width: 350px;
  transition: width 0.3s ease;
}
section p.title {
  padding: 20px;
  margin-bottom: 0px;
  font-weight: bold;
}
section .content {
  overflow-y: scroll;
}
section .content ul {
  /* padding-bottom: 20px; */
}
section .content ul li {
  max-height: 100px;
  transition: margin 0.2s ease, max-height 0.2s ease, padding 0.2s ease, opacity 0.2s ease;
}
section .content ul li .name,
section .content ul li .body {
  padding-left: 20px;
  padding-right: 20px;
}
section .content ul li a.name {
  flex: 1 0 auto;
  text-decoration: none;
  display: flex;
  transition: padding 0.2s ease;
} 
section .content ul li a.name span.bullet {
  flex: 0 0 auto;
  font-family: 'Unicode', caption;
  margin-right: 10px; 
}
section .content ul li a.name span.value {
  flex: 1 1 auto;
}
section .content ul li a.name span.date {
  flex: 0 0 auto;
  text-align: right;
  opacity: 0.25;
  width: 6em;
  transition: opacity 0.2s ease;
}
section .content ul li .body {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
  transition: opacity 0.2s ease, max-height 1s ease, padding 0.2s ease;
}
section .content ul li .body p img {
  width: 100%;
}
section .content ul li .body p img + br + em {
  display: block;
  font-size: 9pt;
  line-height: 1.2;
}



 /* HIDDEN, FADED, HOVERED  */

section .content ul li.faded.hidden {
  pointer-events: none;
  opacity: 0;
  max-height: 0;
  transition: max-height 0.2s ease, opacity 0.2s ease;
}
section .content ul li.faded {
  max-height: 100px;
  opacity: 0.3;
  transition: opacity 0.2s ease, max-height 0.2s ease;
}
section .content ul li a.name.hovered span.date {
  opacity: 1;
}



 /* SELECTED, FADEIN  */

section .content ul li.selected {
  margin-top: 10px;
  margin-bottom: 10px;
  transition: margin 0.2s ease, max-height 0.2s ease, padding 0.2s ease, opacity 0.2s ease;
}
section .content ul li.selected:first-of-type {
  margin-top: 0;
}
section .content ul li.selected a.name {
  border-top: var(--thin-grey);
  border-bottom: var(--thin-grey);
  padding-top: 10px;
  padding-bottom: 10px;
  transition: padding 0.2s ease;
}
section .content ul li.selected .body {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
}
section .content ul li.selected.fadein {
  max-height: 5000px;
  transition: margin 0.2s ease;
  border-bottom: var(--thin-grey);
}
section .content ul li.selected.fadein a.name {
  font-weight: 800;
}
section .content ul li.selected.fadein a.name span.bullet {
  margin-top: 2px;
  font-weight: normal;
}
section .content ul li.selected.fadein .body {
  max-height: 5000px;
  overflow: hidden;
  opacity: 1;
  padding-top: 20px;
}
section .content ul li.selected.fadein .body p:first-of-type {
  margin-top: 0;
  transition: margin 0.2s ease;
}
li.faded.hidden + li.selected.fadein,
li.selected + li.selected.fadein {
  margin-top: 0px;
  margin-bottom: 0px;
  border-bottom: none;
} 




 /* MOBILE  */

#app.mobile {
  font-size: 12pt;
  --thin-grey: 1px solid rgb(0,0,0,0.1);;
  height: 100%;
} 
.mobile #menuButton {
  bottom: 0px;
}
.mobile #menuButton.hidden {
  bottom: -55px;
}
.mobile section#projects, 
.mobile section#projects.expanded, 
.mobile section#collaborators, 
.mobile section#journal, 
.mobile section#journal.expanded, 
.mobile section#about, 
.mobile section#contact,
.mobile section#hall {
  margin-top: 20px;
  max-width: 380px;
  width: 100vw;
}
.mobile section#nav {
  /* padding-bottom: 50px; */
}
.mobile section#nav p#tagline {
  margin-top: 50px;
}
.mobile section p.title {
  padding-top: 10px;
}
.mobile section .content ul {
  padding-bottom: 20px;
}
.mobile section .content ul li a.name span.date {
  width: auto;
}
.mobile .project.selected a.name span.value {
  font-size: 15pt;
}
.mobile .project.selected a.name span.bullet,
.mobile .project.selected.fadein a.name span.bullet {
  margin-top: 4px;
}
.mobile .project.selected a.name span.date,
.mobile .project.selected.fadein a.name span.date {
  margin-top: 2px;
  margin-left: 10px;
} 
.mobile #architecture {
  height: 100%;
}
.mobile #architecture .room {
  height: calc(100% + 100px);
  margin-top: -100px;
}
.mobile #architecture .room .walls {
  height: 100%;
}
.mobile #architecture .room .walls .wall {
  padding-top: 75px;
}
.mobile #architecture .room .walls .wall.left-wall .door {
  max-height: 310px;
  max-width: 60px;
}
.mobile #architecture .room#main-room .walls .wall.left-wall .door {
  max-height: 50%;
  flex-shrink: 1;
}
@media (max-height: 500px) {
  .mobile #architecture #main-room .walls .wall.left-wall .door {
    display: none;
  }
  /* section#nav nav {
    margin-top: 30px;
  } */
}

.mobile #furniture {
  transform: scale(0.9);
  top: 0px;
  left: -150px;
}
.mobile #furniture .trestle {
  left: 1900px;
}
.mobile #furniture .trestle.second {
  left: 1897px;
}
.mobile .posterContainer {
  left: 1530px;
}
.mobile .posterContainer.second {
  left: 1700px;
}

.mobile #back-room,
.mobile #outside {

}
.mobile #architecture .room#back-room .walls .wall.front-wall,
.mobile #architecture .room#back-room .ground {
  /* width: 115px; */
  width: 130px;
}
.mobile #architecture .room#back-room .walls .wall.front-wall .rail table tr td:nth-of-type(n+5) {
  display: none;
}
.mobile #architecture .room#outside .walls .wall.left-wall .rail table tr td:nth-of-type(n+8){
  display: none;
}
.mobile #architecture .room#outside .walls .torrey-container {
  height: 100%;
  /* margin-left: -100px; */
  /* width: 500px; */
}
.mobile #architecture .room#outside .walls .torrey-container .torrey .branches {
  /* margin-top: 100px; */
}
.mobile #architecture .room#outside .walls .torrey-container .torrey .branches {
  transform: scale(0.7);
  margin-right: -100px;
}
.mobile #architecture .room#outside .walls .torrey-container .torrey .trunk {
  transform: scaleX(0.7);
  margin-top: -35px;
  height: 60%;
}
.mobile #architecture .room#outside .walls .torrey-container .torrey .trunk div:nth-of-type(1) {
}
.mobile #architecture .room#outside .walls .torrey-container .torrey .foliage {
  transform: scale(0.7);
  margin-right: -120px;
  margin-top: 40px;
}

@media (max-height: 655px) {
  .mobile #architecture .room .walls .wall {
    padding-top: 6%;
  }
}
</style>
